import { OrderCommentSlice } from './order-comment-types'

export const makeOrderCommentInitialState = (): OrderCommentSlice => {
  return {
    value: '',
  }
}
